export default __webpack_public_path__ + "static/media/nancy-wedding.2a40f3af.jpg";